<template>
  <div class="comment">
    <Form :post="post" :user="user" @saved="pushComment" />
    <Card flat class="comments">
      <h3 v-if="!comments.length">
        {{ $t('blog.comments.no_data') }}
      </h3>
      <Comment
        v-else
        v-for="comment in comments"
        :key="comment.id"
        :value="comment"
        :user="user"
      />
      <Button
        v-if="comments.length && pagination.last_page !== pagination.current_page"
        :disabled="loading"
        @click.native="nexPage"
      >
        {{ $t('blog.comments.load_more') }}
      </Button>
    </Card>
  </div>
</template>

<script>
import Card from '../../../common/Card';
import Button from '../../../common/Button';

import Form from './Form';
import Comment from './Comment';

export default {
  name: 'Comments',
  components: {
    Card,
    Form,
    Comment,
    Button,
  },
  props: {
    user: {
      type: Object,
      description: 'Nochalks user object',
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    comments: [],
    loading: false,
    pagination: {
      per_page: 5,
      page: 1,
      column: 'created_at',
      order: 'ASC',
    },
  }),
  beforeMount() {
    this.getComments();
  },
  methods: {
    pushComment(comment) {
      this.comments = [comment, ...this.comments];
    },
    async nexPage() {
      this.pagination.page += 1;
      await this.getComments();
    },
    async getComments() {
      try {
        this.loading = true;
        const { data } = await window.axios
          .get(`/api/blog/posts/${this.post.id}/comments/list`, {
            params: this.pagination,
          });
        this.comments = [...this.comments, ...data.data];
        this.pagination = data.meta;
        this.pagination.page = this.pagination.current_page;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.comments{
  display: flex;
  flex-direction: column;
}
</style>
